/*
* Pipeline Theme — custom.js
* Fix 1 : Complete the look re-render après premier add-to-cart AJAX
* Fix 2 : Modal upsell autonome — indépendant du scope cart-drawer.liquid
*/

(function() {

  var ctlProducts = [];

  // ── Modal upsell autonome ───────────────────────────────────────────────
  function openCTLModal(idx) {
    var product = ctlProducts[idx];
    if (!product) return;

    var existing = document.getElementById('ctl-modal');
    if (existing) existing.remove();

    var modal = document.createElement('div');
    modal.id = 'ctl-modal';
    modal.style.cssText = 'display:block; position:fixed; top:0; left:0; right:0; bottom:0; background:#fff; z-index:99999; overflow-y:auto;';
    modal.innerHTML =
      '<div style="padding:16px; display:flex; justify-content:space-between; align-items:center;">' +
        '<button id="ctl-modal-back" style="background:none;border:none;font-size:14px;cursor:pointer;">← Back</button>' +
        '<button id="ctl-modal-close" style="background:none;border:none;font-size:22px;cursor:pointer;">×</button>' +
      '</div>' +
      '<div style="overflow:hidden;">' +
        '<div id="ctl-modal-images" style="display:flex;"></div>' +
      '</div>' +
      '<div id="ctl-modal-dots" style="display:flex; gap:4px; padding:10px 16px;"></div>' +
      '<div style="padding:16px;">' +
        '<p id="ctl-modal-title" style="font-size:16px; font-weight:600; margin:0 0 4px;"></p>' +
        '<p id="ctl-modal-price" style="font-size:14px; color:#555; margin:0 0 20px;"></p>' +
        '<p style="font-size:11px; text-transform:uppercase; letter-spacing:0.1em; margin-bottom:10px;">Taille</p>' +
        '<div id="ctl-modal-variants" style="display:flex; flex-wrap:wrap; gap:8px; margin-bottom:24px;"></div>' +
        '<button id="ctl-modal-add" style="width:100%; background:#000; color:#fff; border:none; padding:16px; font-size:12px; letter-spacing:0.1em; text-transform:uppercase; cursor:pointer; opacity:0.4;" disabled>AJOUTER AU PANIER</button>' +
      '</div>';

    document.body.appendChild(modal);

    var selectedVariantId = null;
    var currentImageIndex = 0;
    var totalImages = 0;
    var imgW = 0;

    function closeModal() { modal.remove(); }
    document.getElementById('ctl-modal-back').addEventListener('click', closeModal);
    document.getElementById('ctl-modal-close').addEventListener('click', closeModal);

    // Titre et prix
var ctlCompareAt = product.compare_at_price;
if (ctlCompareAt && ctlCompareAt > product.price) {
  document.getElementById('ctl-modal-price').innerHTML =
    '<span style="font-weight:600;">' + (product.price/100).toFixed(2) + ' $</span>' +
    '<span style="color:#999;text-decoration:line-through;font-weight:400;font-size:11px;margin-left:6px;">' + (ctlCompareAt/100).toFixed(2) + ' $</span>';
} else {
  document.getElementById('ctl-modal-price').textContent = (product.price/100).toFixed(2) + ' $';
}

    // Variantes
    document.getElementById('ctl-modal-variants').innerHTML = product.variants.map(function(v) {
      var sizeNames = ['taille', 'size', 'grandeur'];
var sizeOption = null;
if (product.options) {
  product.options.forEach(function(opt, i) {
    if (sizeNames.indexOf(opt.name.toLowerCase()) !== -1) {
      sizeOption = 'option' + (i + 1);
    }
  });
}
var label = sizeOption ? (v[sizeOption] || v.title) : (v.title.indexOf(' / ') !== -1 ? v.title.split(' / ').pop() : v.title);

      return '<button data-variant="' + v.id + '" style="padding:8px 16px; border:1px solid #ccc; background:#fff; font-size:12px; cursor:pointer;' +
        (!v.available ? 'opacity:0.3; text-decoration:line-through;' : '') + '"' +
        (!v.available ? ' disabled' : '') + '>' + label + '</button>';
    }).join('');

    document.querySelectorAll('#ctl-modal-variants button').forEach(function(b) {
      b.addEventListener('click', function() {
        document.querySelectorAll('#ctl-modal-variants button').forEach(function(x) { x.style.border = '1px solid #ccc'; });
        this.style.border = '2px solid #000';
        selectedVariantId = parseInt(this.getAttribute('data-variant'));
        var addBtn = document.getElementById('ctl-modal-add');
        addBtn.disabled = false;
        addBtn.style.opacity = '1';
      });
    });

    // Add to cart
    document.getElementById('ctl-modal-add').addEventListener('click', function() {
      if (!selectedVariantId) return;
      this.textContent = '...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: selectedVariantId, quantity: 1 })
      }).then(function() {
        closeModal();
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      });
    });

    // Images — fetch produit complet
    fetch('/products/' + product.handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(full) {
        var images = full.images && full.images.length
          ? full.images.map(function(img) {
              var src = img.src || img;
              return src.indexOf('//') === 0 ? 'https:' + src : src;
            })
          : [product.featured_image];

        totalImages = images.length;
        imgW = Math.round(modal.offsetWidth * 0.82);

        var carousel = document.getElementById('ctl-modal-images');
        carousel.style.cssText = 'display:flex; will-change:transform; transform:translateX(0); transition:transform 0.35s ease;';
        carousel.innerHTML = images.map(function(src) {
          return '<div style="width:' + imgW + 'px; min-width:' + imgW + 'px; flex-shrink:0; margin-right:8px;">' +
            '<img src="' + src + '" style="width:' + imgW + 'px; height:' + imgW + 'px; object-fit:cover; display:block;">' +
          '</div>';
        }).join('');

        // Dots
        var dotsContainer = document.getElementById('ctl-modal-dots');
        var lineW = Math.floor((modal.offsetWidth - 32) / images.length - 4);
        dotsContainer.innerHTML = images.map(function(_, i) {
          return '<span style="height:2px; width:' + lineW + 'px; background:' + (i === 0 ? '#000' : '#ddd') + '; display:inline-block;"></span>';
        }).join('');

        // Touch swipe
        var startX, startY, isDragging = false;
        carousel.addEventListener('touchstart', function(e) {
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          isDragging = false;
        }, { passive: true });
        carousel.addEventListener('touchmove', function(e) {
          var dx = e.touches[0].clientX - startX;
          var dy = e.touches[0].clientY - startY;
          if (!isDragging && Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 15) isDragging = true;
          if (isDragging) {
            carousel.style.transition = 'none';
            carousel.style.transform = 'translateX(-' + (currentImageIndex * (imgW + 8) - dx) + 'px)';
          }
        }, { passive: true });
        carousel.addEventListener('touchend', function(e) {
          if (!isDragging) return;
          var diff = startX - e.changedTouches[0].clientX;
          if (Math.abs(diff) > 60) currentImageIndex = diff > 0
            ? Math.min(currentImageIndex + 1, totalImages - 1)
            : Math.max(currentImageIndex - 1, 0);
          carousel.style.transition = 'transform 0.35s ease';
          carousel.style.transform = 'translateX(-' + (currentImageIndex * (imgW + 8)) + 'px)';
          document.querySelectorAll('#ctl-modal-dots span').forEach(function(s, i) {
            s.style.background = i === currentImageIndex ? '#000' : '#ddd';
          });
          isDragging = false;
        }, { passive: true });
      });
  }

  // ── Délégation globale ──────────────────────────────────────────────────
  document.addEventListener('click', function(e) {
    var el = e.target.closest('[data-index]');
    if (!el || !el.closest('#cart-recommendations')) return;
    openCTLModal(parseInt(el.getAttribute('data-index')));
  });

  // ── Re-fetch recommendations après cart update ──────────────────────────
  function refreshCompleteTheLook() {
    var container = document.getElementById('cart-recommendations');
    if (!container) return;

    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (!cart.items || cart.items.length === 0) return;
        var productId = cart.items[0].product_id;
        if (!productId) return;

        fetch('/recommendations/products.json?product_id=' + productId + '&limit=4&intent=complementary')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var wrapper = container.closest('.drawer__complete-look');
            if (!data.products || !data.products.length) {
              if (wrapper) wrapper.style.display = 'none';
              return;
            }
            if (wrapper) wrapper.style.display = '';

            ctlProducts = data.products;

            container.innerHTML = data.products.map(function(p, i) {
              var img = p.featured_image || '';
              return '<div style="min-width:180px; flex-shrink:0; display:flex; gap:10px; align-items:flex-start; scroll-snap-align:start; padding-right:12px; border-right:1px solid #f0f0f0;">' +
                '<img src="' + img + '" data-index="' + i + '" style="width:75px; height:75px; object-fit:cover; flex-shrink:0; cursor:pointer;" alt="' + p.title + '">' +
                '<div>' +
                  '<p style="font-size:11px; color:#888; margin:0 0 4px;">' + p.title + '</p>' +
(p.compare_at_price && p.compare_at_price > p.price
  ? '<p style="font-size:12px;font-weight:600;margin:0 0 8px;display:flex;gap:6px;align-items:baseline;">' +
    '<span>' + (p.price/100).toFixed(2) + ' $</span>' +
    '<span style="color:#999;text-decoration:line-through;font-weight:400;font-size:11px;">' + (p.compare_at_price/100).toFixed(2) + ' $</span>' +
    '</p>'
  : '<p style="font-size:12px;font-weight:600;margin:0 0 8px;">' + (p.price/100).toFixed(2) + ' $</p>'
) +
                  '<button data-index="' + i + '" style="background:none; border:none; border-bottom:1px solid #000; padding:0 0 2px; font-size:11px; color:#000; cursor:pointer;">+ Ajouter</button>' +
                '</div>' +
              '</div>';
            }).join('');
          });
      });
  }

  document.addEventListener('theme:cart:change', function() { setTimeout(refreshCompleteTheLook, 350); });
  document.addEventListener('theme:cart:reload', function() { setTimeout(refreshCompleteTheLook, 350); });

})();
// Sibling swatch color switcher — générique, aucune valeur hardcodée
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.sibling-swatch-btn');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();

  var swatchContainer = btn.closest('.product__grid__sibs__colors');
  if (!swatchContainer) return;

  var card = btn.closest('product-grid-item');
  if (!card) return;

  var url   = btn.dataset.productUrl;
  var title = btn.dataset.productTitle;
  var price = btn.dataset.productPrice;
  var image = btn.dataset.productImage;

  // Extraire le handle depuis l'URL (générique pour tous les produits)
  var handle = url.split('/products/')[1];
card.querySelectorAll('.abibelle-quick-view-btn').forEach(function(b) { b.dataset.productHandle = handle; });

  // --- MISE À JOUR VISUELLE de la carte courante uniquement ---
  var img = null;
card.querySelectorAll('img').forEach(function(el) {
  var rect = el.getBoundingClientRect();
  if (rect.width > 0 && rect.height > 0) img = el;
});
if (img && image) {
  img.src = image;
  img.srcset = '';
  img.sizes = '';
}




  var titleEl = card.querySelector('.product__grid__title');
  if (titleEl) titleEl.textContent = title;

  var priceEl = card.querySelector('.price');
  if (priceEl) priceEl.textContent = price;
    var starsHtml = btn.dataset.starsHtml || '';
  var starsSlot = card.querySelector('[data-abibelle-stars-slot]');
  if (starsSlot && starsHtml) starsSlot.innerHTML = starsHtml;
  var qvBtn = card.querySelector('.abibelle-quick-view-btn');
  if (qvBtn && starsHtml) qvBtn.dataset.starsHtml = starsHtml;

  card.querySelectorAll('[data-grid-link]').forEach(function(link) { link.href = url; });

  // --- SWATCH ACTIVE ---
  swatchContainer.querySelectorAll('.sibling-swatch-btn').forEach(function(b) {
    b.style.border = '1.5px solid #ccc';
    b.style.outline = 'none';
    b.removeAttribute('aria-current');
  });
  btn.style.border = '2px solid #111';
  btn.style.outline = '2px solid #fff';
  btn.setAttribute('aria-current', 'true');

  // --- FETCH VARIANTS + MISE À JOUR FORMULAIRES ---
  if (handle) {
    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var sizeMap = {};
        data.variants.forEach(function(v) {
          if (v.option1) sizeMap[v.option1] = v.id;
          if (v.option2) sizeMap[v.option2] = v.id;
        });

        card.querySelectorAll('[data-add-to-cart]').forEach(function(addBtn) {
          var size = addBtn.textContent.trim();
          var form = addBtn.closest('form');
          var input = form ? form.querySelector('input[name="id"]') : null;
          if (input && sizeMap[size]) {
            input.value = sizeMap[size];
          }
        });
      })
      .catch(function(err) {
        console.error('Sibling fetch error:', err);
      });
  }

}, true);


// ============================================================
// ABIBELLE QUICK VIEW MODAL — Lounge style
// Lit le handle actif via [data-grid-link].href (mis à jour par siblings JS)
// ============================================================
(function () {

  // Injection HTML de la modal (une seule fois au chargement)
  document.body.insertAdjacentHTML('beforeend', [
    '<div id="abibelle-qv-overlay" style="display:none;position:fixed;inset:0;z-index:9998;background:rgba(0,0,0,0.45);backdrop-filter:blur(2px);-webkit-backdrop-filter:blur(2px);"></div>',
    '<div id="abibelle-qv-modal" style="display:none;position:fixed;z-index:9999;bottom:0;left:0;right:0;background:#fff;border-radius:16px 16px 0 0;padding:24px 20px 32px;max-height:90vh;overflow-y:auto;box-shadow:0 -4px 32px rgba(0,0,0,0.14);">',
            '<button id="abibelle-qv-close" style="position:absolute;top:14px;right:16px;width:28px;height:28px;background:#f0f0f0;border:none;border-radius:5px;cursor:pointer;display:flex;align-items:center;justify-content:center;font-size:16px;color:#666;line-height:1;">&times;</button>',
      '<div style="display:flex;gap:16px;align-items:flex-start;margin-bottom:16px;">',
        '<div style="width:100px;height:130px;flex-shrink:0;border-radius:8px;overflow:hidden;background:#f4f4f4;">',
          '<img id="abibelle-qv-img" src="" alt="" style="width:100%;height:100%;object-fit:cover;display:block;">',
        '</div>',
        '<div style="flex:1;min-width:0;padding-top:4px;">',
      '<p id="abibelle-qv-title" style="font-size:13px;font-weight:600;margin:0 0 6px;line-height:1.4;color:#111;"></p>',
'<p id="abibelle-qv-price" style="font-size:13px;margin:0;display:flex;gap:8px;align-items:baseline;"></p>',
      '<div id="abibelle-qv-stars" style="margin-top:6px;"></div>',
        '</div>',
      '</div>',
            '<hr style="border:none;border-top:1px solid #ebebeb;margin:0 0 16px;">',
          '<div id="abibelle-qv-sizes" style="display:flex;flex-wrap:wrap;gap:8px;margin-bottom:20px;"></div>',
      '<button id="abibelle-qv-add" style="width:100%;padding:14px;background:#111;color:#fff;border:none;border-radius:3px;font-size:12px;letter-spacing:0.1em;text-transform:uppercase;cursor:pointer;opacity:0.4;" disabled>Ajouter au panier</button>',
      '<p id="abibelle-qv-msg" style="text-align:center;font-size:12px;color:#888;margin:8px 0 0;min-height:16px;"></p>',
    '</div>'
  ].join(''));

  var overlay  = document.getElementById('abibelle-qv-overlay');
  var modal    = document.getElementById('abibelle-qv-modal');
  var closeBtn = document.getElementById('abibelle-qv-close');
  var imgEl    = document.getElementById('abibelle-qv-img');
  var titleEl  = document.getElementById('abibelle-qv-title');
  var priceEl  = document.getElementById('abibelle-qv-price');
  var sizesEl  = document.getElementById('abibelle-qv-sizes');
  var addBtn   = document.getElementById('abibelle-qv-add');
  var msgEl    = document.getElementById('abibelle-qv-msg');
  var selectedVariantId = null;

  function formatPrice(cents) {
    return new Intl.NumberFormat('fr-CA', { style: 'currency', currency: 'CAD' }).format(cents / 100);
  }

  function openModal() {
    overlay.style.display = 'block';
    modal.style.display   = 'block';
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    overlay.style.display = 'none';
    modal.style.display   = 'none';
    document.body.style.overflow = '';
    selectedVariantId = null;
    msgEl.textContent = '';
  }

  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', closeModal);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeModal();
  });

  // Clic sur le bouton sac — lire le handle actif via [data-grid-link].href
  // (mis à jour automatiquement par le siblings JS existant)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.abibelle-quick-view-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
var card = btn.closest('.product-grid-item') ||
           btn.closest('[data-grid-item]') ||
           btn.closest('.grid__item');

var handle = btn.dataset.productHandle || '';

if (!handle && card) {
  var activeLink = card.querySelector('[data-grid-link]');
  if (activeLink && activeLink.href) {
    var match = activeLink.href.match(/\/products\/([^?#/]+)/);
    if (match && match[1]) handle = match[1];
  }
}

    var starsHtml = btn.dataset.starsHtml || '';
    if (handle) loadQuickView(handle, starsHtml);
  });

  function loadQuickView(handle, starsHtml) {
    // Reset UI
    titleEl.textContent  = '';
    priceEl.textContent  = '';
    document.querySelectorAll('.abibelle-qv-savings').forEach(function(el) { el.remove(); });
    sizesEl.innerHTML    = '';
    imgEl.src            = '';
    imgEl.alt            = '';
    addBtn.disabled      = true;
    addBtn.style.opacity = '0.4';
    addBtn.textContent   = 'Ajouter au panier';
    msgEl.textContent    = '';
    selectedVariantId    = null;
    openModal();

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {

        // Image
        var src = product.featured_image;
        if (src) {
          imgEl.src = src.indexOf('//') === 0 ? 'https:' + src : src;
          imgEl.alt = product.title;
        }

        // Titre + prix
        titleEl.textContent = product.title;
var compareAt = product.compare_at_price;
if (compareAt && compareAt > product.price) {
  document.querySelectorAll('.abibelle-qv-savings').forEach(function(el) { el.remove(); });
  var savings = formatPrice(compareAt - product.price);
  priceEl.innerHTML =
    '<span style="color:#111;font-weight:600;">' + formatPrice(product.price) + '</span>' +
    '<span style="color:#999;text-decoration:line-through;font-weight:400;font-size:11px;">' + formatPrice(compareAt) + '</span>';
  var badgeEl = document.createElement('div');
  badgeEl.className = 'abibelle-qv-savings';
  badgeEl.style.cssText = 'display:inline-block;margin-top:4px;padding:2px 6px;border:1px solid #c0392b;color:#c0392b;background:transparent;font-size:10px;font-weight:600;letter-spacing:0.08em;text-transform:uppercase;';
  badgeEl.textContent = 'ÉCONOMISEZ ' + savings;
  priceEl.insertAdjacentElement('afterend', badgeEl);
} else {
  document.querySelectorAll('.abibelle-qv-savings').forEach(function(el) { el.remove(); });
  priceEl.innerHTML = '<span style="color:#111;">' + formatPrice(product.price) + '</span>';
}


        // Étoiles — HTML pré-rendu par abibelle-stars.liquid, aucun recalcul JS
        var starsContainer = document.getElementById('abibelle-qv-stars');
        if (starsContainer) starsContainer.innerHTML = starsHtml || '';

        // Déterminer quelle option est la taille
        // Pipeline utilise option1 = couleur, option2 = taille (ou option1 si produit simple)
        var sizeOptionIndex = 1; // option2 par défaut
        if (product.options && product.options.length === 1) sizeOptionIndex = 0;

        // Dédupliquer par valeur de taille
        var seen = {};
        var sizeVariants = [];
        product.variants.forEach(function (v) {
          var sizeVal = sizeOptionIndex === 0 ? v.option1 : (v.option2 || v.option1);
          if (!seen[sizeVal]) {
            seen[sizeVal] = true;
            sizeVariants.push({ label: sizeVal, id: v.id, available: v.available });
          }
        });

        sizesEl.innerHTML = '';
        sizeVariants.forEach(function (sv) {
          var b = document.createElement('button');
          b.textContent        = sv.label;
          b.dataset.variantId  = sv.id;
          b.disabled           = !sv.available;
          b.style.cssText      = 'padding:8px 14px;border:1px solid ' +
            (sv.available ? '#ccc' : '#e8e8e8') +
            ';background:#fff;color:' +
            (sv.available ? '#111' : '#ccc') +
            ';font-size:11px;letter-spacing:0.06em;text-transform:uppercase;cursor:' +
            (sv.available ? 'pointer' : 'not-allowed') +
            ';border-radius:2px;' +
            (sv.available ? '' : 'text-decoration:line-through;');
          b.addEventListener('click', function () {
            sizesEl.querySelectorAll('button').forEach(function (x) {
              x.style.border     = '1px solid #ccc';
              x.style.fontWeight = 'normal';
            });
            b.style.border     = '2px solid #111';
            b.style.fontWeight = '600';
            selectedVariantId    = parseInt(sv.id);
            addBtn.disabled      = false;
            addBtn.style.opacity = '1';
          });
          sizesEl.appendChild(b);
        });

        // Auto-sélection si une seule taille disponible
        if (sizeVariants.length === 1 && sizeVariants[0].available) {
          sizesEl.querySelector('button').click();
        }
      })
      .catch(function () {
        msgEl.textContent = 'Impossible de charger ce produit.';
      });
  }

  // Ajout au panier — réutilise le cart drawer Pipeline existant
   addBtn.addEventListener('click', function () {
    if (!selectedVariantId) return;
    addBtn.disabled      = true;
    addBtn.style.opacity = '0.6';
    addBtn.textContent   = '...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: selectedVariantId, quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      addBtn.textContent   = 'Ajouté ✓';
              showAddedToast(titleEl.textContent, imgEl.src);
      addBtn.style.opacity = '1';
      setTimeout(closeModal, 600);
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('theme:cart:change', {
            bubbles: true,
            detail: { cart: cart }
          }));
          document.dispatchEvent(new CustomEvent('theme:cart:reload', {
            bubbles: true
          }));
          setTimeout(function () {
            document.dispatchEvent(new CustomEvent('theme:drawer:open', {
              bubbles: true,
              detail: { drawer: 'cart' }
            }));
          }, 350);
        });
    })
    .catch(function () {
      addBtn.disabled         = false;
      addBtn.style.opacity    = '1';
      addBtn.style.background = '#111';
      addBtn.style.color      = '#fff';
      addBtn.textContent      = 'Ajouter au panier';
      msgEl.textContent       = 'Erreur — veuillez réessayer.';
    });
  });   function showAddedToast(productTitle, imgSrc) {
    var existing = document.getElementById('abibelle-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.id = 'abibelle-toast';
    toast.style.cssText = 'position:fixed;top:0;left:0;right:0;z-index:99999;background:#fff;display:flex;align-items:center;justify-content:space-between;padding:14px 20px;box-shadow:0 2px 12px rgba(0,0,0,0.10);font-size:11px;letter-spacing:0.08em;text-transform:uppercase;transition:opacity 0.4s;';
    toast.innerHTML = '<div style="display:flex;align-items:center;gap:12px;">'
      + (imgSrc ? '<img src="' + imgSrc + '" style="width:36px;height:46px;object-fit:cover;border-radius:3px;">' : '')
      + '<span>' + productTitle + ' &nbsp;·&nbsp; <strong>Article ajouté</strong></span>'
      + '</div>'
      + '<a href="/cart" style="font-size:11px;letter-spacing:0.08em;text-transform:uppercase;color:#111;text-decoration:none;font-weight:600;white-space:nowrap;border-bottom:1px solid #111;">Voir le panier</a>';
    document.body.appendChild(toast);
      toast.querySelector('a').addEventListener('click', function(e) {
    e.preventDefault();
    var cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
    if (cartDrawer) {
      cartDrawer.dispatchEvent(new CustomEvent('theme:drawer:open', {bubbles: false}));
    }
    toast.style.opacity = '0';
    setTimeout(function() { toast.remove(); }, 400);
  });

    setTimeout(function() {
      toast.style.opacity = '0';
      setTimeout(function() { toast.remove(); }, 400);
    }, 4000);
  }


})();
// PDP — Mise à jour compare-at + badge ÉCONOMISEZ au changement de variante
(function() {
  document.addEventListener('theme:variant:change', function(e) {
    var variant = e.detail && e.detail.variant;
    if (!variant) return;

    var compareEl = document.querySelector('[data-compare-price]');
    var badgeEl   = document.querySelector('[data-savings-badge]');
    var amountEl  = document.querySelector('[data-savings-amount]');
    if (!compareEl || !badgeEl || !amountEl) return;

    var cap   = variant.compare_at_price;
    var price = variant.price;

    if (cap && cap > price) {
      var saving = cap - price;
      var fmt = function(cents) {
        return (cents / 100).toFixed(2).replace('.', ',') + '\u00a0$';
      };
      compareEl.textContent = fmt(cap);
      compareEl.style.display = '';
      amountEl.textContent  = fmt(saving);
      badgeEl.style.display = '';
    } else {
      compareEl.style.display = 'none';
      badgeEl.style.display   = 'none';
    }
  });
})();